import Onboarding from '@/pages/Onboarding';

export default function MobileOnboardingScreen() {
  return <Onboarding />;
}

